import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=07097b54"
import script from "./achievement.vue?vue&type=script&lang=js"
export * from "./achievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports